/// <reference path="../../../../tools/typings/tsd.d.ts"/>

module DealerwareWebContent {
    "use strict";
    import IDealerwareVehicle = DealerwareWebServices.IDealerwareVehicle;

    var isFunction = angular.isFunction;

    export interface IVehicleDetailsController {
        // Properties
        vehicle: IDealerwareVehicle;

        // Methods
        loadVehicle(id: number) : void;
        loadVehicleContracts() : void;
        loadVehicleIssues() : void;
        loadVehicleScans() : void;
        allowLoadMap() : boolean;
        loadMap() : void;
    }

    export class VehicleDetailsController implements IVehicleDetailsController {
        public static $inject: string[] = [
            '$stateParams',
            '$q',
            '$mobilityCompanyAuthentication',
            '$dealerwareVehicleFactory',
            'CurrentUser',
            'DealerwareLocationSettingsModel',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$controller',
            '$dealerwareInternationalizationData'
        ];

        public locationSettings: any;
        public locationAllowsPositionUnderContract: boolean;
        public vehicle: any;
        public locationHasGeolite: boolean;
        public labels: {};

        constructor(public $stateParams: any,
                    public $q: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareVehicleFactory: any,
                    public CurrentUser: any,
                    public locationSettingsModel: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $controller: any,
                    public $dealerwareInternationalizationData: any
        ) {
            this.getLabels('vehicles');
            this.loadVehicle(this.$stateParams.vehicleId);
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification(error);
                }
            );
        }

        public loadVehicle(vehicleId: number) : void {
            if (vehicleId) {
                var loader = this.$dealerwareLoading.show('Loading Vehicle...');
                this.$dealerwareVehicleFactory.loadVehicle(
                    this.$mobilityCompanyAuthentication.location.id,
                    vehicleId
                ).then(
                    (response: any) => {
                        this.vehicle = response.vehicle;
                        this.locationSettings = this.$mobilityCompanyAuthentication.location.settings;
                        this.locationHasGeolite = this.$mobilityCompanyAuthentication.location.settings.geolite;
                        this.locationAllowsPositionUnderContract = this.$mobilityCompanyAuthentication.location.settings.view_vehicle_under_contract;

                        if (this.CurrentUser.user.hasRole('admin')) {
                            this.loadVehicleContracts().then(() => {
                                loader.close();
                            });
                        } else {
                            loader.close();
                        }
                    },
                    (response: any) => {
                        loader.close();
                        this.$dealerwareNotification.apiError(response);
                    }
                );
            } else {
                this.$dealerwareNotification.error("No vehicle to load");
            }
        }

        public toDetailSummaryString() : string {

            var s = '';

            if (this.vehicle && angular.isObject(this.vehicle.vehicleDetails)) {
                s = 'MY: ' + this.vehicle.vehicleDetails.data.model_year + '<br>' +
                    'Model: ' + this.vehicle.vehicleDetails.data.model_name + '<br>' +
                    'Stock #: ' + this.vehicle.vehicleDetails.data.stock_number + '<br>' +
                    'License Plate: ' + this.vehicle.vehicleDetails.data.license + '<br>';
            }

            return s;
        };


        public loadVehicleContracts(progress: boolean = true) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.vehicle.vehicleContracts) {
                if (progress) { var loader = this.$dealerwareLoading.show('Loading...'); }

                this.vehicle.loadVehicleContracts()
                    .then((response: any) => { _deferred.resolve({response: response}); })
                    .catch((response: any) => { _deferred.reject(response); })
                    .finally(() => { if (progress) { loader.close(); }});
            }

            return _deferred.promise;
        }

        public notesShown() : void {
            var _self = this;

            if (!_self.vehicle.noteCollection.isNotesLoaded()) {
                var loader = _self.$dealerwareLoading.show("Loading notes...");
                _self.vehicle.loadNotes().then(
                    function(response: any) {
                        loader.close();
                    },
                    function(response: any) {
                        loader.close();
                        _self.$dealerwareNotification.apiError(response);
                    }
                );
            }
        }

        public loadVehicleIssues() : void {
            var _self = this;

            if (!this.vehicle.vehicleIssues) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.vehicle.loadVehicleIssues().then(
                    function(response: any) { loader.close(); },
                    function(response: any) { loader.close(); }
                );
            }
        }

        public loadVehicleScans() : void {
            if (!this.vehicle.vehicleScans) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.vehicle.loadVehicleScans()
                    .then(() => { loader.close(); }
                )
            }
        }

        public loadTollHistory() : void {
            var _self = this;

            if (!this.vehicle.tollHistory) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.vehicle.loadTollHistory().then(
                    function() { loader.close(); },
                    function() { loader.close(); }
                );
            }
        }

        public allowLoadMap() : boolean {

            var vehicleMapCheckShowVehicleController = this.$controller(
                'VehicleMapCheckShowVehicleController', { vehicle: this.vehicle }
            );

            if (!vehicleMapCheckShowVehicleController.shouldShowVehicleMarker()) {

                // Not a map-eligible vehicle, notify of error.
                //
                vehicleMapCheckShowVehicleController.error();

                // Also, don't allow accordion navigation to happen.
                //
                return false;
            }

            return true;
        }

        public loadMap() : void {

            // I twisted and turned to try and avoid just throwing an arbitrary property
            // on the vehicle in order to get the vehicle watcher in VehicleMapDirectiveController
            // to fire but I couldn't figure out a way, including using $controller.  :(
            //
            this.vehicle.showMap = true;
        }

        public loadQRCode() : void {
            var _self = this;

            if (!this.vehicle.qrCode) {
                var loader = this.$dealerwareLoading.show('Loading...');
                this.vehicle.loadQrCode().finally(function() { loader.close(); });
            }
        }

        public renderOffLotBanner() : boolean {
            if (this.locationHasGeolite && this.vehicle && this.vehicle.vehicleDetails && this.vehicle.vehicleDetails.data) {

                const {
                    off_lot: offLotStatus,
                    last_off_lot: lastOffLot,
                } = this.vehicle.vehicleDetails.data;
    
                // addedTime = (days) * (milliseconds in a day)
                const addedTime = 14 * 86400000;
                const currentDate = new Date();
                const lastOffLotDate = new Date(lastOffLot);
                const bannerExpirationDate = new Date(lastOffLotDate.getTime() + addedTime);
                const isBannerExpired = currentDate > bannerExpirationDate
    
                return offLotStatus || !isBannerExpired;
            }
        }
    }

    getDealerwareWebContentModule().controller('VehicleDetailsController', VehicleDetailsController);
}
